import React from 'react';
import {Outlet} from 'react-router-dom';
import {buildProvidersTree} from '../Providers';
import {AssetStatsProvider} from '../Context/Assets/AssetStatsContext';
import {ChangeProductProvider} from '../Context/ChangeProduct/ChangeProductContext';
import {TaopixProvider} from '../Context/TaopixContext';
import {UserFeedbackProvider} from '../Context/UserFeedback/UserFeedbackContext';
import {UserFlowProvider} from '../Context/UserFlow/UserFlowContext';
import {UserInterfaceProvider} from '../Context/UserInterface/UserInterfaceContext';
import ExperienceProvider from '../Experience/ExperienceProvider';
import {TaopixCore} from '@taopix/taopix-core/dist/types/types';

export type DesignerViewProps = {
  sessionRef: string;
  booted: boolean;
  isDev: boolean;
  core: TaopixCore;
};

const DesignerView = ({sessionRef, booted, isDev, core}) => {
  const ProvidersTree = buildProvidersTree([
    [TaopixProvider, {sessionRef, booted, isDev, core}],
    [ExperienceProvider, {}],
    [UserInterfaceProvider, {}],
    [UserFlowProvider, {}],
    [ChangeProductProvider, {}],
    [AssetStatsProvider, {}],
    [UserFeedbackProvider, {}],
  ]);

  return (
    <ProvidersTree>
      <Outlet />
    </ProvidersTree>
  );
};

export default DesignerView;
